import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import ImageOne from "../../assetss/img/founder.jpeg";
import StoryImage from "../../assetss/img/founder.jpeg";
import FounderDayImage from "../../assetss/img/founder.jpeg";
import MentorImage from "../../assetss/img/founder.jpeg";
import Shape1 from "../../assetss/img/edited_shape.png";
import Shape2 from "../../assetss/img/shape-bottom.png";
import { useNavigate } from "react-router-dom";

const ExpertiesHome = () => {
  const navigate = useNavigate();
  return (
    <section className="experties-home">
      <Container>
        <Row>
          <Col md={8}>
            <div className="text-content">
              {/* <div className="subtitle">
                <span className="line"></span> FLEXIBLE SUPPORTED LEARNING
              </div> */}
              <h2 className="title">
                <span><i>Paving the Path to Valuation Profession</i></span>
              </h2>
              <p className="description">
                The genesis of IOV traces back to the unwavering dedication and persistent endeavours of 
                <strong> Late Sh. P.C. Goel</strong>, a visionary acknowledged as the <strong>"Father of Valuation"</strong> in India. late Sh. P.C. Goel, a visionary acknowledged as the "Father of Valuation" in India. 
                A man of forthright decisiveness, creativity, and leadership, his disciplined approach 
                garnered laurels, and drove him to adopt an absolutely new emerging profession of 
                "Valuation". In those days, this field was not recognized. His desire to take Valuation 
                to the heights motivated him to launch the <strong>"Institution of Valuers" on 2nd October 1968,</strong> 
                which is also celebrated as the birthday of Mahatma Gandhi and Lal Bahadur Shastri.
              </p>
              <Button className="btn-grad" onClick={() =>navigate('/page/about-founder')}>Read More</Button>
            </div>
          </Col>
          <Col md={4}>
            <div className="images">
              <div className="image-container">
                {/* Wrapper around the main image to add gap and white background */}
                <div className="image-wrapper">
                  <img src={ImageOne} alt="Our Story" className="main-image" />
                </div>

                {/* Shape on top-left */}
                <div className="it-choose-shape-1">
                  <img src={Shape1} alt="Top Left Shape" />
                </div>

                {/* Shape on bottom-right */}
                <div className="it-choose-shape-2">
                  <img src={Shape2} alt="Bottom Right Shape" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ExpertiesHome;
